import { render, staticRenderFns } from "./MobileMenuIcon.vue?vue&type=template&id=632617d6&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('632617d6')) {
      api.createRecord('632617d6', component.options)
    } else {
      api.reload('632617d6', component.options)
    }
    module.hot.accept("./MobileMenuIcon.vue?vue&type=template&id=632617d6&", function () {
      api.rerender('632617d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Svg/MobileMenuIcon.vue"
export default component.exports